/* MXDVS desktop country list (04.10.2026). Desktop only (990px and up).
   assets/mxdvs-header.js (part 3) opens, closes and fades the list and marks it .is-desktop-dropdown.
   This file:
   1. places the window right under the country button that opened it, its right edge in line with
      the button, 17.5px below it, and keeps it there while the page scrolls or resizes;
   2. draws the custom scrollbar (a hairline track and a thumb: drag the thumb, or click the line to
      page), shown while scrolling and faded out after --mxc-sb-hide.
   Styles: assets/mxdvs-country-desktop.css. Loaded by sections/mxdvs-menu-terminal.liquid. */
(function () {
  if (window.__mxdvsCountryDesktop) return;
  window.__mxdvsCountryDesktop = true;

  var mq = window.matchMedia('(min-width: 990px)');
  var GAP = 17.5;      /* space between the button and the window */
  var EDGE = 17.5;     /* the window never comes closer to the screen edge than this */
  var WIDTH = 350;     /* window width */
  var HEIGHT = 595;    /* highest the window gets (17 x 35px), and never more than 70% of the screen */
  var frame = 0;
  var sbTimer = 0;
  var drag = null;

  function openPanel() {
    return document.querySelector('.disclosure__list-wrapper.country-selector.is-open.is-desktop-dropdown');
  }

  function listOf(panel) { return panel.querySelector('.disclosure__list'); }

  function buttonOf(panel) {
    var list = listOf(panel);
    if (!list || !list.id) return null;
    return document.querySelector('.disclosure__button[aria-controls="' + list.id + '"]');
  }

  function cssNumber(el, name, fallback) {
    var v = parseFloat(getComputedStyle(el).getPropertyValue(name));
    return isNaN(v) ? fallback : v;
  }

  /* 1. Under the button */
  function place(panel) {
    var btn = buttonOf(panel);
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var width = Math.min(WIDTH, vw - EDGE * 2);
    var right = Math.max(EDGE, vw - r.right);
    if (vw - right - width < EDGE) right = Math.max(EDGE, vw - width - EDGE);
    var top = Math.max(EDGE, r.bottom + GAP);
    var height = Math.max(175, Math.min(HEIGHT, vh * 0.7, vh - top - EDGE));
    panel.style.setProperty('--mxc-top', top + 'px');
    panel.style.setProperty('--mxc-right', right + 'px');
    panel.style.setProperty('--mxc-width', width + 'px');
    panel.style.setProperty('--mxc-height', height + 'px');
  }

  /* 2. Scrollbar */
  function bar(panel) {
    var el = panel.querySelector(':scope > .mxc-sb');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'mxc-sb';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="mxc-sb__thumb"></span>';
    panel.appendChild(el);

    el.addEventListener('pointerdown', function (event) {
      var list = listOf(panel), m = el._m;
      if (!list || !m) return;
      var t = el.firstChild.getBoundingClientRect();
      event.preventDefault();
      event.stopPropagation();
      if (event.clientY >= t.top - 8.5 && event.clientY <= t.bottom + 8.5) {
        drag = { y: event.clientY, s: list.scrollTop };
        try { el.setPointerCapture(event.pointerId); } catch (e) {}
      } else {
        list.scrollBy({ top: (event.clientY < t.top ? -1 : 1) * list.clientHeight * 0.8, behavior: 'smooth' });
      }
      wake(panel);
    });
    el.addEventListener('pointermove', function (event) {
      var list = listOf(panel), m = el._m;
      if (!drag || !list || !m || m.track <= m.thumb) return;
      list.scrollTop = drag.s + (event.clientY - drag.y) * m.range / (m.track - m.thumb);
      wake(panel);
    });
    function end() { if (drag) { drag = null; wake(panel); } }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    /* a click on the bar must not reach the backdrop or the page */
    el.addEventListener('click', function (event) { event.stopPropagation(); });
    return el;
  }

  function update(panel) {
    var list = listOf(panel);
    if (!list) return;
    var el = bar(panel);
    var top = list.offsetTop + 8.5;
    var track = panel.clientHeight - top - 8.5;
    var range = list.scrollHeight - list.clientHeight;
    if (track < 35 || range <= 1) { el.classList.remove('is-scrollable'); return; }
    el.classList.add('is-scrollable');
    var thumb = Math.min(track, Math.max(cssNumber(panel, '--mxc-sb-min', 35), track * list.clientHeight / list.scrollHeight));
    var y = (track - thumb) * Math.min(1, Math.max(0, list.scrollTop / range));
    el.style.top = top + 'px';
    el.style.height = track + 'px';
    el.firstChild.style.height = thumb + 'px';
    el.firstChild.style.transform = 'translateY(' + y.toFixed(1) + 'px)';
    el._m = { track: track, thumb: thumb, range: range };
    if (cssNumber(panel, '--mxc-sb-hide', 1200) <= 0) el.classList.add('is-on');
  }

  function wake(panel) {
    var el = panel.querySelector(':scope > .mxc-sb');
    if (!el) return;
    el.classList.add('is-on');
    clearTimeout(sbTimer);
    var hide = cssNumber(panel, '--mxc-sb-hide', 1200);
    if (hide > 0) sbTimer = setTimeout(function () { if (!drag) el.classList.remove('is-on'); }, hide);
  }

  function refresh() {
    frame = 0;
    if (!mq.matches) return;
    var panel = openPanel();
    if (!panel) return;
    place(panel);
    update(panel);
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }

  /* Watch the panels: part 3 adds .is-open and .is-desktop-dropdown when a list opens */
  function watch() {
    var panels = document.querySelectorAll('.disclosure__list-wrapper.country-selector');
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (panel.dataset.mxcWatch) continue;
      panel.dataset.mxcWatch = '1';
      (function (p) {
        new MutationObserver(function () {
          if (p.classList.contains('is-open') && p.classList.contains('is-desktop-dropdown')) {
            refresh();
            setTimeout(function () { refresh(); wake(p); }, 120);
          }
        }).observe(p, { attributes: true, attributeFilter: ['class'] });
        var list = listOf(p);
        if (list) {
          list.addEventListener('scroll', function () {
            if (!p.classList.contains('is-desktop-dropdown')) return;
            schedule();
            wake(p);
          }, { passive: true });
        }
        var input = p.querySelector('.country-filter__input');
        if (input) input.addEventListener('input', function () { setTimeout(schedule, 0); setTimeout(schedule, 350); });
      })(panel);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();
